module.exports = __webpack_public_path__ + "img/level11.72181ac8.png";